import { SET_SALESPERSON_NAME } from "../action";

export function setSalesPersonName(userName) {
    return (dispatch) => {
        dispatch({ type: SET_SALESPERSON_NAME, payload: userName });
    };
}
